import styled from "styled-components";

export const ContentLoginPage = styled.div`
  padding-bottom: 20px;
  padding-top: 66px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  float: left;
  background: white;
  width: 100%;
  background-image: url(https://rtvcplay-v2.s3.amazonaws.com/s3fs-public/field/field_cover_bg/slider/2020-03-19-La-De-Troya-1920X823.jpg);
  @media screen and (min-width: 768px) {
    padding-top: 90px;
  }
  & > span {
    font-size: 12px;
    font-weight: bold;
  }
  & > h1 {
    padding: 0px;
    margin: 0px;
    margin-bottom: 10px;
  }
  & > img {
    max-width: 900px;
    width: 100%;
  }
  & > p {
    max-width: 900px;
    margin: auto;
    text-align: left;
    margin-top: 20px;
  }
`;
